// Adds support for inline links to other aid sections in CMS content, using a
// bbcode-style placeholder: [section=ID]link text[/section]. ID matches either
// an aid section's numeric id or its type (e.g. "risk", "improve"). Mirrors the
// [image=key]...[/image] media-link pattern.
export default {

	methods: {

		parseSectionLinks: function(html) {

			if (!html) return html

			return html.replace(/\[section=["']?([^\]"']+)["']?\]([\s\S]*?)\[\/section\]/g, function(match, ref, label) {
				return '<a href="#" class="section-link" data-section="' + ref + '">' + label + '</a>'
			})

		},

		onSectionLinkClick: function(e) {

			var target = e.target.closest ? e.target.closest('.section-link') : null

			if (!target) return false

			e.preventDefault()
			this.navigateToSection(target.getAttribute('data-section'))

			return true

		},

		navigateToSection: function(ref) {

			var section = this.$_.find(this.$store.getters['data/aid/sections/all'], function(s) {
				return String(s.id) === String(ref) || s.type === ref
			})

			if (!section) return

			// Child sections open their parent (top-level) section.
			var targetId = (section.patient && section.patient.parent) ? section.patient.parent : section.id

			this.$store.commit('session/section/current', targetId)

		}

	}

}
